/**
 * Count cell component
 *
 * Custom cell for ag-grid that shows a count of some elements.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { get, isNumber } from 'lodash';

@Component({
  selector: 'xvi-count-renderer',
  template: `<div>
    {{ label }} <span *ngIf="showValue">({{ value }})</span>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVICountRendererComponent implements AgRendererComponent {
  public label: string = 'Count';
  public value: number = 0;
  public showValue: boolean = true;

  public constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  public agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  public refresh(params: ICellRendererParams): boolean {
    this.label = get(params, 'label', '');
    const rowData = [];
    params.api.forEachNode((node) => rowData.push(node));
    this.value = rowData.length;
    const showValue = get(params, 'showValue', this.showValue);
    this.showValue = showValue && isNumber(this.value);
    this.changeDetectorRef.markForCheck();

    return true;
  }
}
